/**
 * Standard toolkit hook for implementing a manual task preview
 **/
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import invariant from 'tiny-invariant'
import { ManualTask } from 'Automations/watchtower/inbox/manualTasks/types'

export const useManualTaskPreviewToolkit = <TInput>({
  taskId
}: {
  taskId: string
}): {
  manualTask: ManualTask<TInput> | undefined
  isPending: boolean
} => {
  invariant(taskId, 'taskId is required')

  const { manualTask, isPending } = useManualTask({
    taskId
  })

  /**
   * We'll expose the underlying automation data here too later!
   */

  return {
    manualTask: manualTask as ManualTask<TInput> | undefined,
    isPending
  }
}
